export function allowCrmIntegrationFlag() {
  return window.currentUser?.company?.allow_crm_integration ?? true;
}
